import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/knowledge'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.KnowledgePageProps>()(Page.Knowledge)
